// source: pbtypes/gen/scan_output/scan_photo_image.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_calibration_camera_intrinsics_pb = require('../../../pbtypes/gen/calibration/camera_intrinsics_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_camera_intrinsics_pb);
var pbtypes_gen_eigen_lcm_Vector2i_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2i_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2i_pb);
var pbtypes_gen_surface_scan_photo_mode_pb = require('../../../pbtypes/gen/surface_scan/photo_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_photo_mode_pb);
goog.exportSymbol('proto.scan_output.ScanPhotoImage', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_output.ScanPhotoImage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_output.ScanPhotoImage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_output.ScanPhotoImage.displayName = 'proto.scan_output.ScanPhotoImage';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_output.ScanPhotoImage.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_output.ScanPhotoImage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_output.ScanPhotoImage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_output.ScanPhotoImage.toObject = function(includeInstance, msg) {
  var f, obj = {
path: jspb.Message.getFieldWithDefault(msg, 1, ""),
mediaId: jspb.Message.getFieldWithDefault(msg, 5, ""),
dngPath: jspb.Message.getFieldWithDefault(msg, 4, ""),
dngMediaId: jspb.Message.getFieldWithDefault(msg, 6, ""),
kind: jspb.Message.getFieldWithDefault(msg, 7, ""),
photoMode: jspb.Message.getFieldWithDefault(msg, 8, 0),
intrinsics: (f = msg.getIntrinsics()) && pbtypes_gen_calibration_camera_intrinsics_pb.CameraIntrinsics.toObject(includeInstance, f),
imageSize: (f = msg.getImageSize()) && pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_output.ScanPhotoImage}
 */
proto.scan_output.ScanPhotoImage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_output.ScanPhotoImage;
  return proto.scan_output.ScanPhotoImage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_output.ScanPhotoImage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_output.ScanPhotoImage}
 */
proto.scan_output.ScanPhotoImage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPath(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMediaId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDngPath(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDngMediaId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setKind(value);
      break;
    case 8:
      var value = /** @type {!proto.surface_scan.PhotoMode.Enum} */ (reader.readEnum());
      msg.setPhotoMode(value);
      break;
    case 2:
      var value = new pbtypes_gen_calibration_camera_intrinsics_pb.CameraIntrinsics;
      reader.readMessage(value,pbtypes_gen_calibration_camera_intrinsics_pb.CameraIntrinsics.deserializeBinaryFromReader);
      msg.setIntrinsics(value);
      break;
    case 3:
      var value = new pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.deserializeBinaryFromReader);
      msg.setImageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_output.ScanPhotoImage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_output.ScanPhotoImage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_output.ScanPhotoImage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_output.ScanPhotoImage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMediaId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDngPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDngMediaId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getKind();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhotoMode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getIntrinsics();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_calibration_camera_intrinsics_pb.CameraIntrinsics.serializeBinaryToWriter
    );
  }
  f = message.getImageSize();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.scan_output.ScanPhotoImage.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string media_id = 5;
 * @return {string}
 */
proto.scan_output.ScanPhotoImage.prototype.getMediaId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.setMediaId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string dng_path = 4;
 * @return {string}
 */
proto.scan_output.ScanPhotoImage.prototype.getDngPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.setDngPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string dng_media_id = 6;
 * @return {string}
 */
proto.scan_output.ScanPhotoImage.prototype.getDngMediaId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.setDngMediaId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string kind = 7;
 * @return {string}
 */
proto.scan_output.ScanPhotoImage.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.setKind = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional surface_scan.PhotoMode.Enum photo_mode = 8;
 * @return {!proto.surface_scan.PhotoMode.Enum}
 */
proto.scan_output.ScanPhotoImage.prototype.getPhotoMode = function() {
  return /** @type {!proto.surface_scan.PhotoMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.surface_scan.PhotoMode.Enum} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.setPhotoMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional calibration.CameraIntrinsics intrinsics = 2;
 * @return {?proto.calibration.CameraIntrinsics}
 */
proto.scan_output.ScanPhotoImage.prototype.getIntrinsics = function() {
  return /** @type{?proto.calibration.CameraIntrinsics} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_calibration_camera_intrinsics_pb.CameraIntrinsics, 2));
};


/**
 * @param {?proto.calibration.CameraIntrinsics|undefined} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
*/
proto.scan_output.ScanPhotoImage.prototype.setIntrinsics = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.clearIntrinsics = function() {
  return this.setIntrinsics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_output.ScanPhotoImage.prototype.hasIntrinsics = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional eigen_lcm.Vector2iPb image_size = 3;
 * @return {?proto.eigen_lcm.Vector2iPb}
 */
proto.scan_output.ScanPhotoImage.prototype.getImageSize = function() {
  return /** @type{?proto.eigen_lcm.Vector2iPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb, 3));
};


/**
 * @param {?proto.eigen_lcm.Vector2iPb|undefined} value
 * @return {!proto.scan_output.ScanPhotoImage} returns this
*/
proto.scan_output.ScanPhotoImage.prototype.setImageSize = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_output.ScanPhotoImage} returns this
 */
proto.scan_output.ScanPhotoImage.prototype.clearImageSize = function() {
  return this.setImageSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_output.ScanPhotoImage.prototype.hasImageSize = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.scan_output);
